import React from 'react';
import { motion } from 'framer-motion';
import { FaMapMarkerAlt, FaGlobe, FaCar, FaBuilding } from 'react-icons/fa';
const wardData = [
  { ward: 'प्रभाग १', area: 'उत्तर भाग – मुख्य बाजार क्षेत्र', icon: <FaBuilding /> },
  { ward: 'प्रभाग २', area: 'पूर्व भाग – निवासी क्षेत्र', icon: <FaBuilding /> },
  { ward: 'प्रभाग ३', area: 'दक्षिण भाग – शेती क्षेत्र', icon: <FaBuilding /> },
  { ward: 'प्रभाग ४', area: 'पश्चिम भाग – आदिवासी वाडी', icon: <FaBuilding /> },
  { ward: 'प्रभाग ५', area: 'मध्य भाग – ग्रामपंचायत कार्यालय', icon: <FaBuilding /> },
];

const infoCards = [
  {
    icon: <FaMapMarkerAlt />,
    title: 'पत्ता',
    lines: ['नाशेरा ग्रामपंचायत कार्यालय', 'तालुका: मोखाडा | जिल्हा: पालघर', 'महाराष्ट्र – ४०१६०४'],
  },
  {
    icon: <FaGlobe />,
    title: 'भौगोलिक स्थान',
    lines: ['अक्षांश: १९.८१३२°N', 'रेखांश: ७३.४२१०°E', 'उंची: ४५ मीटर (समुद्रसपाटीपासून)'],
  },
  {
    icon: <FaCar />,
    title: 'प्रवास मार्गदर्शन',
    lines: ['मुंबईहून: ११० किमी', 'पालघरहून: ४५ किमी', 'मोखाड्याहून: १२ किमी'],
  },
];

function VillageMap({ language }) {
  return (
    <div style={{ marginTop: '80px' }}>
      <motion.section
        className="hero"
        style={{ height: '50vh' }}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
      >
        <div className="hero-content">
          <motion.h1
            className="page-hero-title"
            initial={{ y: -30, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.2 }}
          >
            गाव नकाशा
          </motion.h1>
          <motion.p
            className="page-hero-sub"
            initial={{ y: 30, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.4 }}
          >
            नाशेरा गावाचा भौगोलिक नकाशा
          </motion.p>
        </div>
      </motion.section>

      <section className="services-section">
        <div className="container">
          <h2 className="section-title"><span>गाव नकाशा</span></h2>

          {/* Google Map */}
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            style={{
              borderRadius: '15px',
              overflow: 'hidden',
              boxShadow: '0 8px 30px rgba(0,0,0,0.15)',
              marginBottom: '2.5rem',
              border: '3px solid rgba(19,136,8,0.25)'
            }}
          >
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d235.89234567890123!2d73.421066!3d19.8132192!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be763defc5360ad%3A0x7607ceee27f25891!2sNashera%20Grampanchayat%20Office!5e0!3m2!1sen!2sin!4v1647123456789!5m2!1sen!2sin"
              width="100%"
              height="450"
              style={{ border: 0, display: 'block' }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="नाशेरा ग्रामपंचायत कार्यालय स्थान"
            />
          </motion.div>

          {/* Info Cards */}
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
            gap: '1.5rem',
            marginBottom: '2.5rem'
          }}>
            {infoCards.map((card, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.12 }}
                whileHover={{ y: -5, boxShadow: '0 10px 30px rgba(0,0,0,0.15)' }}
                style={{
                  background: 'white',
                  borderRadius: '12px',
                  borderLeft: '4px solid #138808',
                  boxShadow: '0 4px 15px rgba(0,0,0,0.08)',
                  padding: '1.4rem 1.5rem',
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: '1rem',
                  transition: 'all 0.3s ease'
                }}
              >
                <div style={{
                  width: '52px', height: '52px',
                  background: 'rgba(19,136,8,0.1)',
                  borderRadius: '50%',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontSize: '1.4rem', color: '#138808', flexShrink: 0
                }}>
                  {card.icon}
                </div>
                <div>
                  <h4 style={{ color: '#2c3e50', fontWeight: '700', fontSize: '1.05rem', marginBottom: '0.5rem' }}>
                    {card.title}
                  </h4>
                  {card.lines.map((line, i) => (
                    <p key={i} style={{ color: '#555', fontSize: '0.92rem', lineHeight: '1.7', margin: 0 }}>{line}</p>
                  ))}
                </div>
              </motion.div>
            ))}
          </div>

          {/* Ward Cards */}
          <h2 className="section-title" style={{ marginBottom: '1.5rem' }}><span>प्रभाग माहिती</span></h2>
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))',
            gap: '1.5rem',
            marginBottom: '2.5rem'
          }}>
            {wardData.map((ward, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                whileHover={{ y: -5, boxShadow: '0 10px 30px rgba(0,0,0,0.15)' }}
                style={{
                  background: 'white',
                  borderRadius: '12px',
                  borderLeft: '4px solid #138808',
                  boxShadow: '0 4px 15px rgba(0,0,0,0.08)',
                  padding: '1.3rem 1.5rem',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '1rem',
                  transition: 'all 0.3s ease'
                }}
              >
                <div style={{
                  width: '48px', height: '48px',
                  background: 'rgba(19,136,8,0.1)',
                  borderRadius: '50%',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontSize: '1.3rem', color: '#138808', flexShrink: 0
                }}>
                  {ward.icon}
                </div>
                <div>
                  <h4 style={{ color: '#138808', fontWeight: '700', fontSize: '1rem', marginBottom: '3px' }}>{ward.ward}</h4>
                  <p style={{ color: '#555', fontSize: '0.9rem', margin: 0 }}>{ward.area}</p>
                </div>
              </motion.div>
            ))}
          </div>

          <motion.p
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            style={{ color: '#666', fontSize: '1rem', lineHeight: '1.8', textAlign: 'center', maxWidth: '800px', margin: '0 auto' }}
          >
            नाशेरा हे मोखाडा तालुक्यातील एक सुंदर गाव असून पश्चिम घाटाच्या पायथ्याशी वसलेले आहे.
            निसर्गसंपन्न परिसर, आदिवासी संस्कृती आणि शेतीप्रधान जीवनशैली हे या गावाचे वैशिष्ट्य आहे.
          </motion.p>
        </div>
      </section>
    </div>
  );
}

export default VillageMap;
